var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tamara-amount global__font-currency-primary",class:_vm.alignClass,attrs:{"dir":_vm.currency === 'SAR' ? 'ltr' : ''},domProps:{"innerHTML":_vm._s(_vm.formattedAmount)}})
}
var staticRenderFns = []

export { render, staticRenderFns }